import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { requester } from "App";
import CustomButton from "components/buttons/CustomButton";
import InputText from "components/inputs/signUp/InputText";
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import BasicPagination from "routes/front/main/vending/mainPage/layout/process/pagination/BasicPagination";
import style from "./BrandList.module.css";
import { useTranslation } from "react-i18next";

function BrandList() {
    const [allBrands, setAllBrands] = useState([]); // 전체 브랜드 데이터
    const [brands, setBrands] = useState([]); // 현재 페이지에 보여줄 브랜드 데이터
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [itemsPerPage] = useState(10); // 페이지당 보여줄 아이템 수
    const navigate = useNavigate();
    const textRef = useRef();
    const { t } = useTranslation();

    useEffect(() => {
        requester.getAllBrandsByCreatorId("data",(result) => {
            const fetchedBrands = result.data;
            setAllBrands(fetchedBrands);
            setTotalPages(Math.ceil(fetchedBrands?.length / itemsPerPage));

            // 첫 페이지 데이터 설정
            const startIndex = 0;
            const paginatedBrands = fetchedBrands?.slice(startIndex, startIndex + itemsPerPage);
            setBrands(paginatedBrands);
        });
    }, []);

    // 페이지 변경 시 보여줄 데이터 업데이트
    useEffect(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const paginatedBrands = allBrands?.slice(startIndex, startIndex + itemsPerPage);
        setBrands(paginatedBrands);
    }, [currentPage, allBrands]);

    const handleEdit = (brand) => {
        navigate(`/admin/brand/list/${brand.id}`, { state: { data: brand } });
    };

    const onSearchClick = () => {
        const keyword = textRef.current.getValue().toLowerCase();

        // 전체 브랜드에서 검색
        const filteredBrands = allBrands.filter(brand =>
            brand.brandName.toLowerCase().includes(keyword) ||
            brand.contents.toLowerCase().includes(keyword)
        );

        setCurrentPage(1);
        setTotalPages(Math.ceil(filteredBrands.length / itemsPerPage));

        // 첫 페이지 데이터 설정
        const paginatedBrands = filteredBrands.slice(0, itemsPerPage);
        setBrands(paginatedBrands);
    };

    const onRefreshClick = () => {
        setCurrentPage(1);
        setTotalPages(Math.ceil(allBrands.length / itemsPerPage));

        const paginatedBrands = allBrands.slice(0, itemsPerPage);
        setBrands(paginatedBrands);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const headers = ['brandImg', 'brandName', 'contents', 'etc'];

    const getNestedValue = (item, path) => {
        const keys = path.split('.');
        let result = item;
        for (let key of keys) {
            if (result && key in result) {
                result = result[key];
            } else {
                return undefined; // 경로에 해당하는 값이 없는 경우
            }
        }
        return result;
    }
    return (
        <Container>
            <VerticalFlex gap={30}>
                <FlexChild>
                    <HorizontalFlex gap={10} alignItems={"flex-start"} justifyContent={"flex-start"}>
                        <FlexChild maxWidth={"400px"}>
                            <InputText ref={textRef} onEnterPress={onSearchClick} />
                        </FlexChild>
                        <FlexChild width={"initial"}>
                            <div className={style.searchButton} onClick={onSearchClick}>
                                <SquareWrapper width={34.5}>
                                    <Center>
                                        <FontAwesomeIcon fontSize={20} icon={fas["faSearch"]} color={"var(--main-color)"} />
                                    </Center>
                                </SquareWrapper>
                            </div>
                        </FlexChild>
                        <FlexChild width={"initial"}>
                            <div className={style.searchButton} onClick={onRefreshClick}>
                                <SquareWrapper width={34.5}>
                                    <Center>
                                        <FontAwesomeIcon fontSize={20} icon={fas["faRedo"]} color={"var(--main-color)"} />
                                    </Center>
                                </SquareWrapper>
                            </div>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                    <div className={style.searchResultSection}  style={{ overflowX: 'auto' }}>
                        <table className={style.table} >
                            <thead>
                                <tr>
                                    {headers.map((header) => (
                                        <th className={style.th} key={header}>{t(header)}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {brands && brands.map((item, index) => (
                                    <tr key={index}>
                                        {headers.slice(0, -1).map((header) => (
                                            <td className={style.td} key={`${index}-${header}`}>
                                                {header.endsWith('Img') && getNestedValue(item, header) ? (
                                                    <SquareWrapper width={50}>
                                                        <Center>
                                                            <img
                                                                src={getNestedValue(item, header)}
                                                                alt="Product"
                                                                style={{
                                                                    maxWidth: '100px',
                                                                    maxHeight: '100px',
                                                                    opacity: item.valid === false ? 0.5 : 1
                                                                }}
                                                            />
                                                        </Center>
                                                    </SquareWrapper>
                                                    // <img src={getNestedValue(item, header)} alt="Product" style={{ maxWidth: '100px', maxHeight: '100px' }} />
                                                ) : (
                                                    getNestedValue(item, header)
                                                )}
                                            </td>
                                        ))}
                                        <td className={style.td}>
                                            <div className={style.button} onClick={() => handleEdit(item)}>
                                                <SquareWrapper width={34.5}>
                                                    <Center>
                                                        <FontAwesomeIcon fontSize={20} icon={fas["faEdit"]} color={"var(--main-color)"} />
                                                    </Center>
                                                </SquareWrapper>
                                            </div>
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </FlexChild>

                {/* 페이지네이션 추가 */}
                <BasicPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />
            </VerticalFlex>
        </Container>
    );
}

export default BrandList;